import React from 'react';
import { UserCheck, MicOff, ClipboardCheck } from 'lucide-react';
import { useSecondScreenData } from '../../../contexts/SecondScreenContext';
import type { WidgetProps } from '../../../types/second-screen.types';

const IncidentCommandWidget: React.FC<WidgetProps> = () => {
  const { state, theme } = useSecondScreenData();
  const isDark = theme === 'dark';
  const tabletop = state?.tabletop;

  if (!tabletop) {
    return (
      <div className={`flex items-center justify-center h-full text-sm ${isDark ? 'text-white/30' : 'text-slate-400'}`}>
        No active exercise
      </div>
    );
  }

  return (
    <div className="flex h-full px-3 py-2 gap-3">
      <div className="flex-1 flex flex-col gap-1 overflow-y-auto min-w-0">
        {tabletop.seats.map(seat => {
          const isSpeaking = tabletop.speaking?.personaId === seat.personaId;
          return (
            <div key={seat.personaId} className="flex flex-col gap-0.5">
              <div className="flex items-center gap-2">
                <span
                  className="flex items-center justify-center w-5 h-5 rounded-full flex-shrink-0"
                  style={isSpeaking ? { animation: 'speaking-ring 1.2s ease-in-out infinite' } : undefined}
                >
                  <UserCheck size={13} className={seat.muted ? 'text-white/20' : 'text-primary'} />
                </span>
                <span className={`text-sm truncate ${isDark ? 'text-white/80' : 'text-slate-700'}`}>{seat.displayName}</span>
                <span className={`text-sm uppercase ${isDark ? 'text-white/30' : 'text-slate-400'}`}>{seat.control.replace('_', ' ')}</span>
                {seat.muted && <MicOff size={11} className="text-red-400 ml-auto flex-shrink-0" />}
              </div>
              {isSpeaking && tabletop.speaking && (
                <p className={`text-lg leading-snug pl-7 ${isDark ? 'text-white/90' : 'text-slate-800'}`}>{tabletop.speaking.text}</p>
              )}
            </div>
          );
        })}
        {tabletop.seats.length === 0 && (
          <p className={`text-sm ${isDark ? 'text-white/30' : 'text-slate-400'}`}>No seats bound yet</p>
        )}
      </div>

      <div className={`flex-shrink-0 w-32 flex flex-col items-center justify-center gap-1 rounded-lg ${isDark ? 'bg-white/5' : 'bg-slate-100'} px-2 py-3`}>
        <ClipboardCheck size={16} className="text-primary" />
        <span className={`text-lg font-bold ${isDark ? 'text-white' : 'text-slate-900'}`}>{tabletop.decisions.made}</span>
        <span className={`text-sm uppercase tracking-wide ${isDark ? 'text-white/40' : 'text-slate-400'}`}>decisions made</span>
      </div>
    </div>
  );
};

export default IncidentCommandWidget;
